import { UnderlyingContext } from 'contexts/underlying/Underlying.context';
import { useContext } from 'react';

export const useUnderlyingContext = () => useContext(UnderlyingContext);
